import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  padded?: boolean;
}

export function Card({ className, padded = true, children, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      className={cn(
        'rounded-lg bg-white shadow-sm ring-1 ring-zinc-200',
        padded && 'p-4',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={cn('border-b border-zinc-200 px-4 py-3 -mx-4 -mt-4 mb-4', className)}
    >
      {children}
    </div>
  );
}

export function CardTitle({ className, children, ...rest }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3 {...rest} className={cn('text-base font-semibold text-zinc-900', className)}>
      {children}
    </h3>
  );
}
